import React, { useEffect, useRef, useState } from 'react';
import * as S from './ModeloCotacao.styles';
import { downloadCotacaoAsImage } from './downloadCotacaoImage';

import logo from '../../midia/logo_maisapoio.png';

const ModeloCotacao = ({ cliente, veiculo, cotacao, usuario, onClose, franquia, CelularRepresentante }) => {
  const cotacaoRef = useRef(null);

  // Bloquear scroll do body quando o modal estiver aberto
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  // Fechar modal com tecla ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  // Dados da cotação
  const dadosCotacao = {
    cotacao: usuario?.codCotacao || '17635525',
    data: new Date().toLocaleDateString('pt-BR'),
    validade: '10 DIAS',
    nomeCliente: cliente?.nome || 'NOME DO CLIENTE',
    veiculo: veiculo?.modelo || 'FALTA MODELO DO VEÍCULO',
    placa: veiculo?.placa || 'ABC-1234',
    ano: veiculo?.ano || '0000',
    valorAvaliado: parseFloat(veiculo?.valorFipe).toLocaleString('pt-br', { style: 'currency', currency: 'BRL'}),
    consultor: {
      nome: franquia?.nome ,
      telefone: CelularRepresentante
    }
  };

  // ----------------------------

  const planoCarro = [
    { item: 'COBERTURA A ROUBO / FURTO / COLISÃO E PERDA TOTAL', valor: 'INCLUSO', percentual: '100% Fipe' },
    { item: 'INCÊNDIO POR COLISÃO', valor: 'INCLUSO', percentual: '100% Fipe' },
    { item: 'FENÔMENOS DA NATUREZA', valor: 'INCLUSO', percentual: '100% Fipe' },
    { item: 'PROTEÇÃO P/3° DANOS MATERIAIS ', valor: 'Até R$ 50 MIL', percentual: '-' },
    { item: 'ASSISTÊNCIA 24 HORAS - PANE ELÉTRICA/MECÂNICA', valor: '400 KM Total', percentual: '-' },
    { item: 'ASSISTÊNCIA 24 HORAS - SINISTRO', valor: 'KM Ilimitado', percentual: '-' },
    { item: 'CARRO RESERVA', valor: 'INCLUSO', percentual: '15 DIAS' },  
    { item: 'COBERTURA DE VIDROS, FARÓIS E RETROVISORES', valor: 'INCLUSO', percentual: '40% Participação' },
    { item: 'COBERTURA PEQUENAS AVARIAS', valor: 'Até R$ 500,00', percentual: '40% Participação' },
    { item: 'CHAVEIRO ( SOMENTE ABERTURA DE PORTAS) ', valor: 'Até R$ 100,00', percentual: '2X ANO' },
    { item: 'HOTEL EM CASO DE EVENTOS', valor: 'Até R$ 150,00', percentual: '2X ANO' },
    { item: 'RETORNO A DOMICÍLIO APÓS EVENTO', valor: 'Até R$ 300,00', percentual: '2X ANO' },
    { item: 'VEÍCULOS ACIMA DE 100MIL - OBRIGATÓRIO RASTREAMENTO', valor: 'R$ 59,90', percentual: '-' },
  ];

  const planoMotocicleta = [
    { item: 'COBERTURA A ROUBO / FURTO / COLISÃO E PERDA TOTAL', valor: 'INCLUSO', percentual: '100% Fipe' },
    { item: 'INCÊNDIO POR COLISÃO', valor: 'INCLUSO', percentual: '100% Fipe' },
    { item: 'FENÔMENOS DA NATUREZA', valor: 'INCLUSO', percentual: '100% Fipe' },
    { item: 'ASSISTÊNCIA 24 HORAS - PANE ELÉTRICA/MECÂNICA', valor: '400 KM Total', percentual: '-' },
    { item: 'ASSISTÊNCIA 24 HORAS - SINISTRO', valor: 'KM Ilimitado', percentual: '-' },
    { item: 'REVISÃO GRATUITA (SOMENTE LUBRIFICAÇÃO)', valor: '3 X ANO', percentual: '-' },
  ];

  const [planoBeneficio, setplanoBeneficio] = useState([]);

  useEffect(() => {
    if(veiculo.tipo){
      setplanoBeneficio(veiculo.tipo === "motocicleta"? planoMotocicleta : planoCarro)
    }
  }, [veiculo.tipo])
  
  // ------------------------

  const [valorMensal, setvalorMensal] = useState(null);
  const [valorAdesao, setvalorAdesao] = useState(null);

  useEffect(() => {
    if (cotacao.valorCotacao) {
      setvalorMensal(parseFloat(cotacao.valorCotacao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));  
    };
    if (cotacao.valorAdesao) {
      setvalorAdesao(parseFloat(cotacao.valorAdesao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));  
    }
  }, [cotacao.valorCotacao, cotacao.valorAdesao]);

  const cotacaoVeiculo = [
    { item: `MENSALIDADE MÉDIA : ${valorMensal}` },
    { item: `TAXA DE FILIAÇÃO : ${valorAdesao}` },
    // { item: 'FRANQUIA 5%' },
  ];

  // Handler para download da imagem
  const handleDownloadImage = async () => {
    await downloadCotacaoAsImage(cotacaoRef.current, dadosCotacao, planoBeneficio, cotacaoVeiculo);
  };

  return (
    <S.Container>
      <S.ModalOverlay onClick={onClose}>
        <S.ModalContent onClick={(e) => e.stopPropagation()}>
          
          <S.CloseButton onClick={onClose}>✕</S.CloseButton>
          <S.DownloadButton onClick={handleDownloadImage} title="Baixar como imagem">
            📥
          </S.DownloadButton>
          
          <S.CotacaoWrapper ref={cotacaoRef}>
            <S.Header>
              <S.LogoSection>
                  <S.LogoMain>
                    <img src={logo} alt="Logo" style={{ width: '100%', minWidth:"200px", maxWidth:"300px" }} />
                  </S.LogoMain>
              </S.LogoSection>
              
              <S.InfoSection>
                <S.InfoItem>COTAÇÃO: {dadosCotacao.cotacao}</S.InfoItem>
                <S.InfoItem>DATA: {dadosCotacao.data}</S.InfoItem>
                <S.InfoItem>VALIDADE: {dadosCotacao.validade}</S.InfoItem>
              </S.InfoSection>
            </S.Header>

            {/* INFORMAÇÕES DO VEÍCULO */}
            <S.VehicleInfo>
              <p>OLÁ, ESTA É UMA COTAÇÃO PARA O SEU VEÍCULO</p>
              <p><strong>{dadosCotacao.veiculo}</strong></p>
              <p>PLACA: <strong>{dadosCotacao.placa}</strong> </p>
              <p>AVALIADO EM <strong>{dadosCotacao.valorAvaliado}</strong></p>
            </S.VehicleInfo>

            <S.SectionTitle>BENEFICIOS</S.SectionTitle>
            <S.Table>
              <tbody>
                {planoBeneficio.map((item, index) => (
                  <tr key={index}>
                    <S.Table_2>{item.item}</S.Table_2>
                    <S.Table_2 center>{item.valor}</S.Table_2>
                    <S.Table_2 center>{item.percentual}</S.Table_2>
                  </tr>
                ))}
              </tbody>
            </S.Table>

            {/* COTAÇÃO DO VEÍCULO */}
            <S.SectionTitle>VALORES</S.SectionTitle>
            <S.Table>
              <tbody style={{fontSize:"12px"}}>
                {cotacaoVeiculo.map((item, index) => (
                  <tr key={index}>
                    <S.Table_2>{item.item}</S.Table_2>
                  </tr>
                ))}
              </tbody>
            </S.Table>

            {/* CONSULTOR */}
            <S.SectionTitle>CONSULTOR</S.SectionTitle>
            <S.ConsultorInfo>
              <S.ConsultorItem>NOME: <strong>{dadosCotacao.consultor.nome}</strong></S.ConsultorItem>
              <S.ConsultorItem>TELEFONE: <strong>{dadosCotacao.consultor.telefone}</strong> </S.ConsultorItem>
            </S.ConsultorInfo>
          </S.CotacaoWrapper>
        </S.ModalContent>
      </S.ModalOverlay>
    </S.Container>
  );
};

export default ModeloCotacao;
